import { useState, useCallback } from "react";
import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";
import Button from "../Buttons/Button";
import PhoneNumberChangeModal from "./PhoneNumberChangeModal";

// Read-only display of the user's verified SMS two-factor number with an action to change
// it: the number itself is only editable through the verification flow in the modal, so
// the inline input stays disabled.
const PhoneNumberField = ({ phoneNumber, canUpdate }) => {
  const t = useFormatMessage();
  const label = t(intlMessages.label);
  const editLabel = t(intlMessages.edit);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEditClicked = useCallback(() => setIsModalOpen(true), []);
  const handleModalClosed = useCallback(() => setIsModalOpen(false), []);

  return (
    <div className="row">
      <div className="col-md-6">
        <label className="form-label" htmlFor="profile-phone-number">
          {label}
        </label>

        <div className="d-flex align-items-center">
          {/* Don't use a StringInput here to avoid the number to leak into the profile
              edition mutation, even if disabled. */}
          <input
            id="profile-phone-number"
            className="form-control"
            type="tel"
            value={phoneNumber || ""}
            disabled
          />

          {canUpdate && (
            <Button
              type="button"
              className="btn btn-secondary btn-md margin-left-sm"
              label={editLabel}
              onClick={handleEditClicked}
            />
          )}
        </div>
      </div>

      {isModalOpen && <PhoneNumberChangeModal onClose={handleModalClosed} />}
    </div>
  );
};

export default PhoneNumberField;

const intlMessages = defineMessages({
  label: {
    id: "profile.phoneNumber.label",
    defaultMessage: "Numéro de mobile (double authentification)"
  },
  edit: {
    id: "profile.phoneNumber.edit",
    defaultMessage: "Modifier"
  }
});
